import { mergeStyles} from "office-ui-fabric-react";

export const container = mergeStyles({
    display: "flex",
    flexDirection: "column"
})

